import { api } from '../api';

export const configApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    config: builder.query<Record<string, unknown>, void>({
      query: () => 'api/conf/',
      keepUnusedDataFor: 600,
    }),
  }),
});
